import { InjectionToken } from '@angular/core';

import { ExportOption } from '../components/common-export-button/common-export-button.types';

export const GLOBAL_EXPORT_OPTIONS = new InjectionToken<ExportOption[]>('globalExportOptions');
